import React from 'react';
import Image from 'next/legacy/image';
import { AmenitiesCategoriesNames } from 'apolloClient/types/Amenities';

export interface AmenityToRender {
  name: AmenitiesCategoriesNames;
  label: string;
  items: string;
  icon?: any;
}

interface AmenitiesGridProps {
  labels: (AmenityToRender | null)[] | null;
}

const AmenitiesGrid: React.FC<AmenitiesGridProps> = ({ labels }) => {
  if (!labels) return null;

  return (
    <div className="grid" style={{ gridTemplateColumns: '20px auto 1fr' }}>
      {labels.map((category) => {
        if (!category) return null;
        const { items, label, name, icon } = category;
        return (
          <React.Fragment key={name}>
            <div className="mt-2 flex-shrink-0">
              <Image src={icon} alt={label} />
            </div>
            <div className="pb-1 pt-1 font-sohneKraftig text-14-26-0.3 md:text-16-26-0.3 whitespace-nowrap overflow-hidden ml-4">
              {label}
            </div>
            <div className="pb-4 pt-1 pl-6 pr-2 border-l border-beige-dark min-w-0 ml-4">
              {items}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default AmenitiesGrid;
